import { render } from "./DataCollectionTrigger.vue?vue&type=template&id=b28300dc&scoped=true"
import script from "./DataCollectionTrigger.vue?vue&type=script&lang=js"
export * from "./DataCollectionTrigger.vue?vue&type=script&lang=js"

import "./DataCollectionTrigger.vue?vue&type=style&index=0&id=b28300dc&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28300dc"]])

export default __exports__